import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import config from "../config.js"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SalesChart1 = () => {
  const [salesData, setSalesData] = useState([]);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/SalesworkbookToJson`);
        setSalesData(response.data.data.Data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  const prepareChartData = () => {
    const salesmanData = salesData.reduce((acc, curr) => {
      if (!acc[curr.Salesman]) {
        acc[curr.Salesman] = { sales: [], revenue: [] };
      }

      acc[curr.Salesman].sales.push(curr.Sales);
      acc[curr.Salesman].revenue.push(curr.Revenue);

      return acc;
    }, {});

    const labels = Object.keys(salesmanData);
    const salesDataValues = Object.values(salesmanData);

    const salesPerSalesman = salesDataValues.map((data) => ({
      label: 'Sales',
      data: data.sales,
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      borderColor: 'rgba(255, 99, 132, 1)',
      borderWidth: 1,
    }));

    const revenuePerSalesman = salesDataValues.map((data) => ({
      label: 'Revenue',
      data: data.revenue,
      backgroundColor: 'rgba(54, 162, 235, 0.5)',
      borderColor: 'rgba(54, 162, 235, 1)',
      borderWidth: 1,
    }));

    return {
      labels: labels,
      datasets: [...salesPerSalesman, ...revenuePerSalesman]
    };
  };

  const chartData = prepareChartData();

  return (
    <Box>
      {salesData.length === 0 ? (
        <CircularProgress />
      ) : (
        <Box>
          <Typography variant="h5" gutterBottom>
            Sales and Revenue per Salesman
          </Typography>
          <Bar
            data={chartData}
            options={{
              indexAxis: 'y',
              scales: {
                x: {
                  stacked: false,
                },
                y: {
                  stacked: true
                }
              }
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default SalesChart1;

